import React from 'react';
import { connect } from 'react-redux';

import {PieChart, Pie, ResponsiveContainer, Cell} from 'recharts';
import { Metric, ComponentWithUrl, INSTAGRAM_COLORS, YOUTUBE_COLORS } from './../../../Utils/Utils.js';
import Loader from '../../../Loader/Loader.js';
import numeral from '../../../../../node_modules/numeraljs/numeral.js';

class SocialGoalsInstagramYouTube extends ComponentWithUrl {
 render() {
   const { loading, data, title, instagram_goal, youtube_goal } = this.props;

   if (loading) {
     return (
       <Loader minHeight={400} col={'col-sm-6 col-md-6'} />
     );
   }

   const instagram_percentage = data.instagram.value * 100 / instagram_goal
   const youtube_percentage = data.youtube.value * 100 / youtube_goal

   const graph_data = {
     "instagram_count": [{
         "value": instagram_percentage
       }, {
         "value": instagram_percentage > 100 ?  0 : 100 - instagram_percentage
       }],

     "youtube_count": [{
       "value": youtube_percentage
        }, {
        "value": youtube_percentage > 100 ?  0 : 100 - youtube_percentage
      }]
   };

   return (

     <div className="col-xs-12 col-md-6 d-flex">
       <div className="widget">
         <header className="widget__header">
           <h5 className="widget__title">{title}</h5>
         </header>

         <div className="row mt-3">
           <div className="col-6 col-sm-6 col-md-6">
             <h5 className="widget__subtitle widget--instagram">Instagram</h5>
             <h6 className="mb-0">Followers</h6>
             <Metric {...data.instagram} size={"md"}/>
           </div>

           <div className="col-6 col-sm-6 col-md-6">
            <h5 className="widget__subtitle widget--youtube">YouTube</h5>
            <h6 className="mb-0">Subscribers</h6>
            <Metric {...data.youtube } size={"md"}/>
          </div>
         </div>

         <div className="row mt-3">
           <div className="col-6">
             
               <ResponsiveContainer height={270}>
                 <PieChart height={100}>
                   <Pie dataKey="value" startAngle={180} endAngle={0} data={graph_data.instagram_count} outerRadius="100%" innerRadius="80%">
                  {
                    graph_data.instagram_count.map((entry, index) => (
                      <Cell key={`cell-${entry}`} fill={INSTAGRAM_COLORS[index]} />
                    ))
                  }
                 </Pie>
                 <text x="50%" y="40%" textAnchor="middle" dominantBaseline="middle" className="piechart-metric__primary">
                   { numeral(instagram_percentage).divide(100).format('%') }
                 </text>
               </PieChart>
              </ResponsiveContainer>

              <div className="piechart-metric__secondary">
                <h6 className="text-muted text-center">{ numeral(instagram_goal).format(0.0) } Goal</h6>
              </div>
           </div>

           <div className="col-6">

            <ResponsiveContainer height={270}>
               <PieChart height={100}>
                 <Pie dataKey="value" startAngle={180} endAngle={0} data={graph_data.youtube_count} outerRadius="100%" innerRadius="80%">
                {
                  graph_data.youtube_count.map((entry, index) => (
                    <Cell key={`cell-${entry}`} fill={YOUTUBE_COLORS[index]} />
                  ))
                }
               </Pie>
               <text x="50%" y="40%" textAnchor="middle" dominantBaseline="middle" className="piechart-metric__primary">
                 { numeral(youtube_percentage).divide(100).format('%') }
               </text>
             </PieChart>
            </ResponsiveContainer>

            <div className="piechart-metric__secondary">
              <h6 className="text-muted text-center">{ numeral(youtube_goal).format(0.0) } Goal</h6>
            </div>
           </div>

         </div>
       </div>
     </div>
   );
 }
}

const mapStateToProps = (state, props) => {
  const myState = state.data[props.url];
  return {
    data: myState ? myState.data : null,
    loading: myState ? myState.loading : true,
  };
};

export default connect(mapStateToProps)(SocialGoalsInstagramYouTube);
